import styled from 'styled-components';
import PropTypes from '@userzoomlibraries/toolkit-js-utils/prop-types';
import React from 'react';
import useDataAttributes from '@userzoomlibraries/toolkit-react-utils/use-data-attributes';
import { u as useIndicator } from './index2.js';
import { u as useTabs } from './index.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["className"],
    _excluded2 = ["disabled"];

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { _defineProperty$1(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$1(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var TabIndicator$1 = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  var dataAttributes = useDataAttributes(rest, {
    excludedAttributes: ['data-disabled']
  });

  var _useIndicator = useIndicator(),
      _useIndicator2 = _slicedToArray(_useIndicator, 1),
      _useIndicator2$ = _useIndicator2[0],
      disabled = _useIndicator2$.disabled,
      indicatorPosition = _objectWithoutProperties(_useIndicator2$, _excluded2);

  var _useTabs = useTabs(),
      isVertical = _useTabs.isVertical;

  var classnames = "gz-tabs__indicator ".concat(className);

  if (isVertical) {
    classnames = "".concat(classnames, " gz-tabs__indicator--vertical");
  }

  return /*#__PURE__*/jsx("div", _objectSpread$1({
    ref: ref,
    className: classnames,
    style: indicatorPosition,
    "data-disabled": disabled // eslint-disable-next-line react/jsx-props-no-spreading

  }, dataAttributes));
});
TabIndicator$1.COMPONENT_ID = 'Gearz.Tabs.Indicator';
TabIndicator$1.displayName = TabIndicator$1.COMPONENT_ID;
TabIndicator$1.propTypes = {
  className: PropTypes.stringWithDescription('Custom class to be applied.')
};
TabIndicator$1.defaultProps = {
  className: ''
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var TabIndicator = styled(TabIndicator$1).withConfig({
  componentId: "gz-tabs-1677758460838__sc-r6wnic-0"
})(["background-color:#314fff;position:absolute;transition:left 300ms,right 300ms,width 300ms,height 300ms,top 300ms,opacity 300ms;will-change:left,right,width,height,top,opacity;z-index:2;&.gz-tabs__indicator--vertical{right:0;width:3px;}&:not(.gz-tabs__indicator--vertical){bottom:0;height:3px;}&[data-disabled=\"true\"]{opacity:0.24;}"]);
TabIndicator.displayName = TabIndicator$1.displayName;
TabIndicator.propTypes = _objectSpread(_objectSpread({}, TabIndicator$1.propTypes), {}, {
  vertical: PropTypes.boolWithDescription('Flag to determine if the tabs element is vertical. (internal use)')
});
TabIndicator.defaultProps = _objectSpread(_objectSpread({}, TabIndicator$1.defaultProps), {}, {
  vertical: false
});

export { TabIndicator as T };
